if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-cart-upsell-button]');
      this.buttonText = this.querySelector('[data-cart-upsell-button-text]');
      this.variantId = Number(this.dataset.variantId);

      if (!this.button || !this.variantId) return;

      this.button.addEventListener('click', this.handleAdd);
    }

    disconnectedCallback() {
      if (!this.button) return;

      this.button.removeEventListener('click', this.handleAdd);
    }

    handleAdd = async () => {
      if (!this.button || this.button.disabled) return;

      const originalText = this.buttonText.textContent;

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.buttonText.textContent = 'A adicionar…';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: this.variantId,
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          throw new Error(`Cart add failed: ${response.status}`);
        }

        window.location.reload();
      } catch (error) {
        console.error('[Cart Upsell]', error);

        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.buttonText.textContent = originalText;
      }
    };
  }

  customElements.define('cart-upsell', CartUpsell);
}